<template>
    <div>

        <client-history-title
                title="Motivo Latente:"
                icon="fas fa-search" />

        <v-divider class="my-2"></v-divider>

        <v-textarea
                v-model="technical_reason"
                auto-grow rows="2" fillled
                placeholder="Escribe algo..."
        />

        <client-history-title
                title="Información:"
                icon="fas fa-user" />

        <v-divider class="my-2"></v-divider>

        <template v-if="event && event.client.is_adult === false">

            <v-textarea
                    v-model="relevant_health_info"
                    auto-grow rows="2" fillled
                    label="Datos Relevantes de Salud" />

            <v-textarea
                    v-model="relevant_school_info"
                    auto-grow rows="2" fillled
                    label="Datos Relevantes Escolares" />

            <v-textarea
                    v-model="relevant_family_info"
                    auto-grow rows="2" fillled
                    label="Datos Relevantes Familiares" />

        </template>

        <template v-else>
            <v-textarea
                    v-model="relevant_health_info"
                    auto-grow rows="2" fillled
                    label="Datos Relevantes" />
        </template>

        <client-history-title
                title="Apreciación Clínica:"
                icon="fas fa-brain" />

        <v-divider class="my-2"></v-divider>

        <v-textarea
                v-model="clinical_comments"
                auto-grow rows="2" fillled
                placeholder="Escribe algo..."
        />

        <client-history-title
                title="Pasos a Seguir:"
                icon="fas fa-clipboard-list" />

        <v-divider class="my-2"></v-divider>

        <v-textarea
                v-model="indications"
                auto-grow rows="2" fillled
                placeholder="Escribe algo..."
        />

    </div>
</template>

<script>

    import ClientHistoryTitle from '../../ClientHistoryTitle'

    export default{
        components: {ClientHistoryTitle},
        props:{
            event:{
                type: Object,
                required: true
            },
            readOnly:{
                type: Boolean,
                default: false
            }
        },
        data(){
            return {
                technical_reason: '',
                relevant_health_info: '',
                relevant_school_info: '',
                relevant_family_info: '',
                clinical_comments: '',
                indications: '',
            }
        },
        mounted(){
            this.setDefaults()
        },
        methods:{
            setDefaults(){

                var vm = this
                if(!vm.psychologicalRecord) return

                vm.technical_reason = vm.psychologicalRecord.technical_reason
                vm.relevant_health_info = vm.psychologicalRecord.relevant_health_info
                vm.relevant_school_info = vm.psychologicalRecord.relevant_school_info
                vm.relevant_family_info = vm.psychologicalRecord.relevant_family_info
                vm.clinical_comments = vm.psychologicalRecord.clinical_comments
                vm.indications = vm.psychologicalRecord.indications

            },
        },
        computed:{
            psychologicalRecord(){
                var vm = this
                return vm.event && vm.event.psychological_record || null
            }
        },
        watch:{
            technical_reason(val){
                var vm = this
                vm.$emit('change:technical_reason', val)
            },
            relevant_health_info(val){
                var vm = this
                vm.$emit('change:relevant_health_info', val)
            },
            relevant_school_info(val){
                var vm = this
                vm.$emit('change:relevant_school_info', val)
            },
            relevant_family_info(val){
                var vm = this
                vm.$emit('change:relevant_family_info', val)
            },
            clinical_comments(val){
                var vm = this
                vm.$emit('change:clinical_comments', val)
            },
            indications(val){
                var vm = this
                vm.$emit('change:indications', val)
            },
        }
    }
</script>
